import React, {useEffect, useState} from 'react';
import { useLocation, Outlet, Navigate } from 'react-router-dom'

import Header from '../Nav/Header.tsx';
import Wrap from './Wrap.tsx';

import LoginForm from '../LoginOut/LoginForm.tsx';

import { useAuthContext } from '../../features/auth/hooks/use-auth-context.ts';
import { useProfileContext } from '../../features/auth/hooks/use-profile-context.ts';
import { getRoutes } from '../../index.js';

const Base = () => {
    const { isAuthenticated, checkLoginStatus } = useAuthContext();
    const { needsInitialReview, isProfileLoaded } = useProfileContext();
    const [appIsLoading, setAppIsLoading] = useState(true);
    const routes = getRoutes();

    useEffect(() => {
        checkLoginStatus();
        setAppIsLoading(false)
    }, [checkLoginStatus]);

    const matchRoute = (pathname:string, config:any) => {
        return config.find(({ path }) => {
            const regexPath = path.replace(/:[^/]+/g, "([^/]+)");
            const regex = new RegExp(`^${regexPath}$`);
            return regex.test(pathname);
        });
    }

    const isPathProtected = (pathname:string, config:any) => {
        const match = matchRoute(pathname, config);
        return match ? match.protected : null;
    }

    const pathRequiresValidation = (pathname:string, config:any) => {
        const match = matchRoute(pathname, config);
        return match ? !!match.requiresValidation : false;
    }

    const location = useLocation();

    if (appIsLoading) {
        return <div>Lade...</div>;
    }

    if (isAuthenticated && !isPathProtected(location.pathname, routes)) {
        return <Navigate to="/" replace />
    }

    if (!isAuthenticated && isPathProtected(location.pathname, routes)) {
        return (
            <>
                <Header />
                <div id="wrap">
                    <LoginForm />
                </div>
            </>
        )
    }

    if (!isAuthenticated) {
        return (
            <>
                <Header />
                <div id="wrap">
                    <Outlet />
                </div>
            </>
        )
    }

    // Authenticated: wait for the profile (role/validation status) before
    // deciding so we never flash a guarded screen or redirect prematurely.
    if (!isProfileLoaded) {
        return <div>Lade...</div>;
    }

    if (needsInitialReview && pathRequiresValidation(location.pathname, routes)) {
        return <Navigate to="/erstpruefung" replace />
    }

    return(
        <>
            <Header />
            <Wrap />
        </>
    )
}

export default Base;